import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";
import { getDefaultStore, useAtomValue } from "jotai";

import { RecurrenceCreateHeader } from "@/components/recurring-appointment/recurrence-create-header";
import { RescheduleRecurrenceReview } from "@/components/recurring-appointment/reschedule-recurrence-review";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";
import {
  recurringAppointmentFormAtom,
  recurringSessionsAtom,
  recurringSlotAtom,
} from "@/lib/atoms/recurring-appointment-form-atom";
import { rescheduleRecurrenceAtom } from "@/lib/atoms/reschedule-recurrence-form-atom";
import { getFrequencyLabel } from "@/lib/helpers/recurrence";
import { differenceInMinutes } from "@/lib/time";

import type { JSX } from "react";

const RescheduleRecurrenceReviewPage = (): JSX.Element => {
  const form = useAtomValue(recurringAppointmentFormAtom);
  const slot = useAtomValue(recurringSlotAtom);
  const router = useRouter();

  const duration =
    slot.horaInicio && slot.horaFim
      ? differenceInMinutes({ startTime: slot.horaInicio, endTime: slot.horaFim })
      : 0;

  const subtitle = [
    form.unitAcronym,
    `${form.appointmentTypeName} – ${duration} min`,
    getFrequencyLabel(form.frequency),
  ]
    .filter(Boolean)
    .join(" • ");

  return (
    <RoundedLayout>
      <RecurrenceCreateHeader
        title="Revisar recorrência"
        subtitle={subtitle}
        onBack={() => router.history.back()}
      />
      <Page>
        <RescheduleRecurrenceReview />
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute("/recurring-appointments/reschedule/review")({
  component: RescheduleRecurrenceReviewPage,
  beforeLoad: () => {
    const store = getDefaultStore();
    const slot = store.get(recurringSlotAtom);
    const sessions = store.get(recurringSessionsAtom);
    const { codAgendamentoRecorrente, oldSessions } = store.get(rescheduleRecurrenceAtom);

    if (
      codAgendamentoRecorrente === 0 ||
      oldSessions.length === 0 ||
      !slot.horaInicio ||
      sessions.length === 0
    ) {
      redirect({ to: "/calendar", throw: true });
    }
  },
});
